import React, {useState, useEffect, useRef} from 'react'
import {connect} from 'react-redux';
import noResultsStyle from './no-result.scss'
import styles from './country-slider.scss'
import flagStyles from './country-flags.scss'
import SearchText from '../../../common/SearchText';
import { escapeRegExp } from '../../../utills';
import historyHandler from 'jd-library/historyHandler';
import SliderWrapper from 'jd-library/SliderWrapper';
import useOnScroll from 'jd-library/useOnScroll';

const popularCountries = [{
    countryCode: "IN",
    countryID: 100,
    countryName: "India",
    isdCode: 91,
},
{
    countryCode: "CN",
    countryID: 45,
    countryName: "China",
    isdCode: 86
},
{
    countryCode: "KR",
    countryID: 203,
    countryName: "South Korea",
    isdCode: 82
},
{
    countryCode: "ID",
    countryID: 101,
    countryName: "Indonesia",
    isdCode: 62
},
{
    countryCode: "DE",
    countryID: 81,
    countryName: "Germany",
    isdCode: 49,
},
{
    countryCode: "JP",
    countryID: 109,
    countryName: "Japan",
    isdCode: 81
},
{
    countryCode: "MY",
    countryID: 131,
    countryName: "Malaysia",
    isdCode: 60,
	lastCountry:true
}];

const getGroupedList = (filteredList) => filteredList.reduce((groups, cur) => {
		const letter = cur.countryName.charAt(0);
		groups[letter] = groups[letter] || [];
		groups[letter].push(cur);
		return groups;
	}, {})

const CountrySliderList = (props) => {
	const countryList = props.countryList;
	const [searchText, updateSearchText] = useState("");
	const [scrolled, setScroll] = useState(false);
    const [scrollEl, setScrollEl] = useState(null);
	const inputRef = useRef(null);
	var matchRegex = new RegExp(escapeRegExp(searchText), "i");
	const filteredList = searchText
		? countryList.filter(item => matchRegex.test(item.countryName))
		: countryList;
	const groupedList = filteredList.length ? getGroupedList(filteredList) : null;
	const onCountrySelect = (country) => {
		props.updateCountry(country)
		window.history.back();
	}
	useEffect(() => {
		inputRef.current && inputRef.current.focus();
		
	}, []);
	const showNoResultsFound =  !groupedList && searchText;
    const onCountryInputChange = (e) => {
        updateSearchText(e.target.value)
    }
	const onCountrySearchClear = () => {
		updateSearchText('');
	}

	useOnScroll({
        callback : (e,scrollObj) => {
          if(scrollObj.currScroll.scrollTop){
            setScroll(true);
          }else{
             setScroll(false)
          }
        },
        element : !scrollEl ? null : scrollEl,
        deps: [scrollEl]
    })
    
	return (
        <>
        <SliderWrapper 
            header={{    
                    className: 'country-header',
                    hasBorder: true,
                    searchBox:true,
					searchVariant:'edit',
					raised: scrolled,
                    showOnlySearch:true ,
                    inputProps:{
                        placeholder: 'Search Country Of Origin',
                        onChange: onCountryInputChange,
						leftIconClass: 'icon-HDRback',
						leftIconHolderClass: 'country-back-icon',
						leftIconClick: () => {
							historyHandler.closeCurrent();
						},
						onClear : onCountrySearchClear
                    }                 
                }}        
            onHidden={() => {
                props.onHidden && props.onHidden();
            }}
            slider={{
                className: styles['country-slider'] + " " + (props.isMobile ? styles['mob-country-slider'] : styles['web-ccountry-slider']),
			}}
			updateScrollContRef={(scrollref) => {
				setScrollEl(scrollref)
			}}
            isMobile = {props.isMobile}
			enableHeader
        >
			<div className={styles['country-list']}>
				{!searchText && <>
					<div className={`${styles['group-header']}`}>
						POPULAR COUNTRIES
					</div>
					{popularCountries.map((cur) => {
                        return getSingleCountryMarkup(cur, onCountrySelect, cur.lastCountry)
                    })}
                    <div className={`${styles['group-header']}`}>
						ALL COUNTRIES
					</div>
				</>}
				{groupedList && countryListMarkup(groupedList, onCountrySelect, searchText)}
				{showNoResultsFound && <NoResultsFound />}
			</div>
            </SliderWrapper>
		</>
	)
}

const countryListMarkup = (groupedList, onCountrySelect, searchText) => {
	let markup = [];
	//let lastCountryGroup = Object.keys(groupedList).pop();
	for(let key in groupedList){
		const countryGroup = groupedList[key];
		countryGroup.map((country, index) => {
			const lastCountry = country.lastCountry || (index === countryGroup.length - 1);
			markup.push(getSingleCountryMarkup(country, onCountrySelect, lastCountry, searchText))
		})
	}
	return markup;
}

const getHighlightedSearch = (item, searchText) => {
	return (
		<SearchText 
			text={item}
			search={searchText}
		/>
	)
}

const getSingleCountryMarkup = (country, onCountrySelect, lastCountry, searchText) => {
	return (
		<div className={`${styles['country-item']} ${lastCountry && styles['no-bottom-border']}`} onClick={() => onCountrySelect(country)}>
			<span className={`${styles['flag']} ${flagStyles['sprite']} ${flagStyles['sprite-'+country.countryCode]}`}></span>
			<span className={styles['item-text']}>
				{getHighlightedSearch(country.countryName, searchText)}
			</span>
		</div>
	)
}

const mapStateToProps = (state, props) => ({
	...props,
	imgSrc: "https://image1.jdomni.in/jdomni_email/OmniNoResultsFound_1911051227.png",
    isMobile:state.library.deviceData.isMobile
})

const NoResultsFound = connect(mapStateToProps)(props => {
	return (
		<div className={noResultsStyle['no-results']}>
			<img src={props.imgSrc} />
			<div className={noResultsStyle['no-results-text']}>
				No Results Found
			</div>
		</div>
	);
});

export default CountrySliderList;